import { render, staticRenderFns } from "./AccountPasswordReset.vue?vue&type=template&id=9fadc31c&"
import script from "./AccountPasswordReset.vue?vue&type=script&lang=ts&"
export * from "./AccountPasswordReset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports